// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__0m6nu","innerBlock":"PageHeader_innerBlock__Apiui","icon":"PageHeader_icon__toWGM","name":"PageHeader_name__ppJ1j"};